import { useState, useEffect } from "react";
import { getLocaleKey, reinitializeLocale } from "../utils/localizationHelper";

/**
 * Hook to monitor cookie changes and reinitialize locale when needed
 * Useful for QA/production where header/footer may set cookies after app loads
 */
export function useLocaleMonitor() {
  const [currentLocale, setCurrentLocale] = useState(() => {
    const initial = getLocaleKey();
    console.log('[useLocaleMonitor] Initial locale:', initial);
    return initial;
  });

  useEffect(() => {
    const getCookieValue = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      return parts.length === 2 ? parts.pop().split(";").shift() : null;
    };

    let lastLangCode = getCookieValue("CK_LANG_CODE");
    let lastIsoCode = getCookieValue("CK_ISO_CODE");

    // Check cookies every 500ms for changes
    const interval = setInterval(() => {
      const newLangCode = getCookieValue("CK_LANG_CODE");
      const newIsoCode = getCookieValue("CK_ISO_CODE");

      if (newLangCode !== lastLangCode || newIsoCode !== lastIsoCode) {
        console.log("[useLocaleMonitor] Cookie change detected, reinitializing locale...", {
          old: { lang: lastLangCode, country: lastIsoCode },
          new: { lang: newLangCode, country: newIsoCode }
        });

        // Reinitialize locale with new cookies
        const newLocale = reinitializeLocale();
        
        // Force a full page reload to apply new locale properly
        // This is necessary because components have already rendered with old strings
        console.log("[useLocaleMonitor] Reloading page to apply new locale:", newLocale);
        window.location.reload();

        lastLangCode = newLangCode;
        lastIsoCode = newIsoCode;
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return currentLocale;
}
